import { render, staticRenderFns } from "./LivePlayVideo.vue?vue&type=template&id=d4c68d56&scoped=true"
import script from "./LivePlayVideo.vue?vue&type=script&lang=js"
export * from "./LivePlayVideo.vue?vue&type=script&lang=js"
import style0 from "./LivePlayVideo.vue?vue&type=style&index=0&id=d4c68d56&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4c68d56",
  null
  
)

export default component.exports